import config from '../../config';
import Keycloak from 'keycloak-js';

class AuthProvider {
  constructor() {
    this.client = new Keycloak(config.keycloak);
  }

  init() {
    return new Promise((resolve, reject) => {
      this.client
        .init({
          onLoad: 'check-sso',
          pkceMethod: 'S256',
          checkLoginIframe: false,
        })
        .then(() => resolve())
        .catch(() => reject());
    });
  }

  login() {}

  logout() {}
}

export default new AuthProvider();
